import { lazy } from 'react';

const PendingCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/consult/pending-certification',
			component: lazy(() => import('./PendingCertificationContainer'))
		}
	]
};

export default PendingCertificationConfig;